<template>
  <div class="addEditBrandIncreasePage">
    <div class="upload_img">
      <van-uploader
        :max-count="1"
        :after-read="afterRead"
        v-if="params.logo == ''"
      >
        <div class="box flex-rowc">
          <img src="../../assets/images/upload_img.png" alt="" />
          <p>上传品牌LOGO图片</p>
        </div>
      </van-uploader>

      <div class="block" v-else>
        <img :src="params.logo" alt="" />
        <div class="del flex-rowc" @click="handleDelImg">
          <div class="icon"><van-icon name="delete-o" /></div>
          <span>删除</span>
        </div>
      </div>
    </div>

    <div class="form_wrap">
      <h1>品牌名称</h1>
      <div class="input_box">
        <van-field v-model="params.labelname" placeholder="品牌中文名称" />
      </div>
      <div class="input_box">
        <van-field
          v-model="params.labelcont_e"
          placeholder="Chinese brand name"
        />
      </div>
      <div class="input_box">
        <van-field
          v-model="params.labelcont_y"
          placeholder="Nhãn hiệu Tên Trung Quốc"
        />
      </div>
      <div class="input_box">
        <van-field
          v-model="params.labelcont_m"
          placeholder="ชื่อแบรนด์ ภาษาจีน"
        />
      </div>
      <div class="input_box">
        <van-field v-model="params.labelcont_t" placeholder="Nama tanda Cina" />
      </div>

      <!-- <div class="block">
        <h1>排序</h1>
        <div class="input_box">
          <van-field v-model.number="params.sort" placeholder="请输入排序" />
        </div>
      </div> -->

      <div class="state">
        <h1>品牌状态</h1>
        <van-radio-group
          v-model="params.labelstate"
          class="flex-around state_radio"
        >
          <van-radio name="1" checked-color="#ee0a24">启用</van-radio>
          <van-radio
            name="0"
            :disabled="id != '' ? true : false"
            checked-color="#ee0a24"
            >停用</van-radio
          >
        </van-radio-group>
      </div>

      <div class="primary-button" @click="query">保存确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBrandList,
  uploadImage,
  addBrand,
  editBrand,
  encryptstringview,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "brandDetail",
  data() {
    return {
      searchTxt: "",
      qyid: 0,
      id: "",

      labelcont: "",
      labelcont_e: "",
      labelcont_y: "",
      labelcont_m: "",
      labelcont_t: "",
      logo: "",
      radio: "",
      createman: "",

      params: {
        qyguid: "",
        labelname: "",
        labelcont: "",
        sort: "",
        labelstate: "1",
        linkurl: "",
        apppath: "",
        logo: "",
        labelcont_e: "",
        labelcont_y: "",
        labelcont_m: "",
        labelcont_t: "",
        createman: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.params.qyguid = USERINFO.qy.qyguid;
    } else {
      this.params.qyguid = 0;
    }
    this.params.createman = USERINFO.truename
      ? USERINFO.truename
      : USERINFO.nickname;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    init(id) {
      let { qyguid } = this.params;
      getBrandList({ qyguid }).then((res) => {
        let dataNew = res;
        let filter = dataNew.filter((v) => v.id == id);
        if (filter.length == 0) return;
        this.params.labelname = filter[0].labelname
          ? filter[0].labelname
          : filter[0].labelcont;
        this.params.labelcont = filter[0].labelcont;
        this.params.sort = filter[0].sort;
        this.params.labelstate = filter[0].labelstate
          ? filter[0].labelstate
          : 0;
        this.params.linkurl = filter[0].linkurl;
        this.params.apppath = filter[0].apppath;
        this.params.labelcont_e = filter[0].labelcont_e;
        this.params.labelcont_y = filter[0].labelcont_y;
        this.params.labelcont_m = filter[0].labelcont_m;
        this.params.labelcont_t = filter[0].labelcont_t;
        this.params.createman = filter[0].createman;
        if (filter[0].logo && filter[0].logo.indexOf("http") == -1) {
          this.params.logo = "/Upload/" + filter[0].logo;
        } else {
          this.params.logo = filter[0].logo;
        }
      });
    },

    handleReturn() {
      history.back();
    },
    handleDelImg() {
      this.params.logo = "";
    },

    // logo上传
    afterRead(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.params.logo = res.url;
        }
        Toast.clear();
      });
    },

    query() {
      let { params, id } = this;
      if (params.logo == "") {
        this.$toast("请上传品牌LOGO");
        return;
      }
      if (params.labelname == "") {
        this.$toast("请输入品牌中文名称");
        return;
      }
      if (params.labelstate == "" && params.labelstate != 0) {
        this.$toast("请选择品牌状态");
        return;
      }
      if (id == "") {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        addBrand(params).then((res) => {
          Toast.clear();
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              // this.clearData();
              history.back();
            }, 1500);
          } else {
            this.clearData();
            this.$toast.fail(res.message);
          }
        });
      } else {
        params.id = id;
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editBrand(params).then((res) => {
          Toast.clear();
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              history.back();
            }, 1500);
          } else {
            this.$toast.fail(res.message);
          }
        });
      }
    },
    clearData() {
      this.params.labelname = "";
      this.params.radio = "";
      this.params.linkurl = "";
      this.params.apppath = "";
      this.params.labelstate = "";
      this.params.labelcont_y = "";
      this.params.labelcont_m = "";
      this.params.labelcont_t = "";
      this.params.logo = "";
      this.params.sort = "";
    },
  },
};
</script>
<style lang="less" scoped>
.addEditBrandIncreasePage {
  .upload_img {
    width: 100%;
    height: 750px;
    background: #e4e4e4;
    position: relative;
    /deep/ .van-uploader {
      width: 100%;
      height: 100%;
    }
    /deep/ .van-uploader__wrapper {
      width: 100%;
      height: 100%;
    }
    /deep/ .van-uploader__input-wrapper {
      width: 100%;
    }
    .box {
      flex-flow: column;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 176px;
      }
      p {
        font-size: 30px;
        color: #515151;
        text-align: center;
        margin-top: 60px;
      }
    }
    .block {
      height: 100%;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .del {
      position: absolute;
      background: rgba(246, 37, 96, 0.8);
      height: 70px;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 44px;
      color: #fff;
      text-align: center;
      line-height: 70px;
      span {
        font-size: 26px;
        margin-left: 10px;
      }
    }
  }
  .form_wrap {
    padding: 116px 75px 340px;
    h1 {
      font-size: 30px;
      color: #444444;
      margin-bottom: 35px;
      text-align: center;
      font-weight: 400;
    }
    .input_box {
      margin-bottom: 30px;
    }
    .block {
      margin-top: 80px;
    }
    .state {
      margin: 160px auto;
      /deep/ .van-radio__label {
        font-size: 14px;
      }
    }
  }
}
</style>